import { restClient } from '@/Core'

import type { TransportRequestTransition } from './TransportRequest.types'

/**
 * Перехід запиту чи тендера — `POST <restUrl>/{uuid}/<перехід>` (`SPEC-022` §6).
 *
 * Відповідь — оновлена картка; `?permissions=true` просить разом із нею
 * `_permissions`, щоб кнопки одразу показали новий стан без окремого
 * перечитування. Чи можна перехід — вирішує бек: 400 «Недозволений перехід.»,
 * 422 — поле тіла (причина програшу).
 */
export const RunTransportRequestTransitionTask = async (
    restUrl: string,
    uuid: string,
    transition: Exclude<TransportRequestTransition, 'convert'>,
    body: Record<string, unknown> = {}
): Promise<Record<string, unknown> | null> => {
    const response = (await restClient.post(`${restUrl}/${uuid}/${transition}?permissions=true`, {
        json: body,
    })) as unknown

    return response !== null && typeof response === 'object' ? (response as Record<string, unknown>) : null
}
